var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "container-app-search",
      attrs: { id: "form-search-popover" }
    },
    [
      _c(
        "div",
        {
          staticClass: "studio-page-header",
          class: { "studio-page-header-long": !_vm.is_sidebar_minimized },
          staticStyle: {
            "padding-bottom": "0 !important",
            "padding-top": "15px !important"
          }
        },
        [
          _c("div", { staticStyle: { display: "-webkit-box" } }, [
            _c("i", {
              staticClass:
                "fa fa-arrow-left font-weight-bold cursor-pointer display-inline m__t--7",
              staticStyle: { "vertical-align": "top" },
              on: {
                click: function($event) {
                  _vm.$router.push("/form-data")
                }
              }
            }),
            _vm._v(" "),
            _c("img", {
              staticClass: "m__l--10",
              attrs: {
                src: require("@/assets/icon-sidebar/data-manager.svg"),
                width: "32",
                height: "32"
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "m__l--10 p__t--2" }, [
              _c("div", { staticClass: "label-header-access-application" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.dataGroup ? _vm.dataGroup.name : "Table Not Found"
                    ) +
                    "\n        "
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex m__t--30" }, [
            _c(
              "div",
              {
                staticClass: "tab-experience-manager m__r--35",
                class: {
                  "tab-experience-manager-active": _vm.tabSelected === "general"
                },
                on: {
                  click: function($event) {
                    _vm.tabSelected = "general"
                  }
                }
              },
              [_vm._v("\n        GENERAL\n      ")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "tab-experience-manager",
                class: {
                  "tab-experience-manager-active":
                    _vm.tabSelected === "privileges"
                },
                on: {
                  click: function($event) {
                    _vm.tabSelected = "privileges"
                  }
                }
              },
              [_vm._v("\n        PRIVILEGES\n      ")]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _vm.tabSelected === "general"
        ? _c("div", { staticClass: "studio-page-content" }, [
            _c(
              "div",
              { staticClass: "privilege-data-manager-container-general" },
              [
                _c("label", [_vm._v(" Group Name ")]),
                _vm._v(" "),
                _vm.isAdmin
                  ? _c("img", {
                      staticClass: "cursor-pointer m__l--5",
                      attrs: { src: require("@/assets/icon/pencil-edit.svg") },
                      on: {
                        click: function($event) {
                          _vm.openModal("name")
                        }
                      }
                    })
                  : _vm._e(),
                _c("br"),
                _vm._v(" "),
                _c("b", [
                  _vm._v(_vm._s(_vm.dataGroup ? _vm.dataGroup.name : ""))
                ]),
                _vm._v(" "),
                _c("hr"),
                _vm._v(" "),
                _c("label", [_vm._v(" Description ")]),
                _vm._v(" "),
                _vm.isAdmin
                  ? _c("img", {
                      staticClass: "cursor-pointer m__l--5",
                      attrs: { src: require("@/assets/icon/pencil-edit.svg") },
                      on: {
                        click: function($event) {
                          _vm.openModal("desc")
                        }
                      }
                    })
                  : _vm._e(),
                _c("br"),
                _vm._v(" "),
                _c("b", [
                  _vm._v(_vm._s(_vm.dataGroup ? _vm.dataGroup.description : ""))
                ])
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isOpenModalGeneral
        ? _c(
            "div",
            {
              staticClass: "modal-title-list-view data",
              attrs: { id: "modalGeneral" }
            },
            [
              _c("div", { staticClass: "label-group-modal" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.modeModal === "name" ? "Group Name" : "Description"
                    ) +
                    "\n    "
                )
              ]),
              _vm._v(" "),
              _vm.modeModal === "name"
                ? _c(
                    "b-form-group",
                    {
                      class: { "error-input": _vm.$v.table_group_name.$error }
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.table_group_name,
                            expression: "table_group_name"
                          }
                        ],
                        attrs: { type: "text", placeholder: "Ex : t_name" },
                        domProps: { value: _vm.table_group_name },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.table_group_name = $event.target.value
                          }
                        }
                      })
                    ]
                  )
                : _c(
                    "b-form-group",
                    {
                      class: {
                        "error-input": _vm.$v.table_group_description.$error
                      }
                    },
                    [
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.table_group_description,
                            expression: "table_group_description"
                          }
                        ],
                        attrs: { placeholder: "Ex : This group for....." },
                        domProps: { value: _vm.table_group_description },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.table_group_description = $event.target.value
                          }
                        }
                      })
                    ]
                  ),
              _vm._v(" "),
              _c("div", { staticClass: "d-flex justify-content-end mt-4" }, [
                _c(
                  "button",
                  {
                    staticClass: "button-border mr-2",
                    on: { click: _vm.closeModalGeneral }
                  },
                  [_vm._v("\n        Close\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  { staticClass: "button-blue", on: { click: _vm.updateData } },
                  [_vm._v("\n        Apply\n      ")]
                )
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.tabSelected === "privileges"
        ? _c(
            "div",
            { staticClass: "studio-page-content" },
            [
              !_vm.load_first
                ? _c(
                    "v-client-table",
                    {
                      ref: "privilegesTableComponent",
                      staticClass:
                        "jTable table-access-application table-access-privilege",
                      attrs: {
                        columns: _vm.columns,
                        options: _vm.option,
                        data: _vm.data_table
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "tablegroup_id",
                          fn: function(props) {
                            return _c(
                              "div",
                              {
                                on: {
                                  click: function($event) {
                                    _vm.openDetail(props.row)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n        " +
                                    _vm._s(props.row.tablegroup_id) +
                                    "\n      "
                                )
                              ]
                            )
                          }
                        },
                        {
                          key: "name",
                          fn: function(props) {
                            return _c(
                              "div",
                              {
                                on: {
                                  click: function($event) {
                                    _vm.openDetail(props.row)
                                  }
                                }
                              },
                              [
                                _c("div", { staticClass: "d-flex" }, [
                                  _c(
                                    "div",
                                    { staticClass: "m__r--7" },
                                    [
                                      props.row.user_info.photo_url
                                        ? _c("b-img", {
                                            staticClass:
                                              "m-1 round-bordered-img\n              img-circle staff-img image-popup-link b-page-theme td",
                                            attrs: {
                                              src:
                                                props.row.user_info.photo_url,
                                              rounded: "circle",
                                              alt: "img"
                                            }
                                          })
                                        : _c("b-img", {
                                            staticClass:
                                              "m-1 round-bordered-img\n              img-circle staff-img image-popup-link b-page-theme td",
                                            attrs: {
                                              src: require("@/assets/logo/user1.png"),
                                              rounded: "circle",
                                              alt: "img"
                                            }
                                          })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "m__t--5" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "privilege-user-info-fullname"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(props.row.user_info.fullname)
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "privilege-user-info-email"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(props.row.user_info.email)
                                        )
                                      ]
                                    )
                                  ])
                                ])
                              ]
                            )
                          }
                        },
                        {
                          key: "privilege",
                          fn: function(props) {
                            return _c(
                              "div",
                              {
                                on: {
                                  click: function($event) {
                                    _vm.openDetail(props.row)
                                  }
                                }
                              },
                              _vm._l(props.row.privilege, function(
                                item,
                                index
                              ) {
                                return _c(
                                  "span",
                                  {
                                    key: index,
                                    staticClass: "privilege-data-manager",
                                    class: item
                                  },
                                  [
                                    _vm._v(
                                      "\n          " +
                                        _vm._s(
                                          item.replace("_", " ").toUpperCase()
                                        ) +
                                        "\n        "
                                    )
                                  ]
                                )
                              })
                            )
                          }
                        },
                        {
                          key: "created_at",
                          fn: function(props) {
                            return _c(
                              "div",
                              {
                                on: {
                                  click: function($event) {
                                    _vm.openDetail(props.row)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n        " +
                                    _vm._s(
                                      _vm.convertDateTime(props.row.created_at)
                                    ) +
                                    "\n      "
                                )
                              ]
                            )
                          }
                        },
                        {
                          key: "delete",
                          fn: function(props) {
                            return _c("div", {}, [
                              _vm.isAdmin
                                ? _c("i", {
                                    staticClass:
                                      "fa fa-lg fa-trash cursor-pointer",
                                    on: {
                                      click: function($event) {
                                        _vm.actionDeletePrivilege(
                                          props.row.user_company_id
                                        )
                                      }
                                    }
                                  })
                                : _vm._e()
                            ])
                          }
                        }
                      ])
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "custom-search",
                          attrs: { slot: "beforeFilter" },
                          slot: "beforeFilter"
                        },
                        [
                          _c(
                            "b-form",
                            { attrs: { inline: "" } },
                            [
                              _c(
                                "b-button",
                                {
                                  staticClass:
                                    "btn grey btn-import-form m__r--5",
                                  on: { click: _vm.openAdd }
                                },
                                [
                                  _c("i", { staticClass: "fa fa-plus fa-lg" }),
                                  _vm._v(" Add\n          ")
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-form",
                                {
                                  attrs: { inline: "" },
                                  on: {
                                    keypress: function($event) {
                                      if (
                                        !("button" in $event) &&
                                        $event.keyCode !== 13
                                      ) {
                                        return null
                                      }
                                      $event.preventDefault()
                                      _vm.filter(_vm.filter_data)
                                    }
                                  }
                                },
                                [
                                  _c("b-form-select", {
                                    staticClass: "m__r--5",
                                    attrs: {
                                      options: _vm.options_search,
                                      placeholder: "Filter By"
                                    },
                                    model: {
                                      value: _vm.select_type,
                                      callback: function($$v) {
                                        _vm.select_type = $$v
                                      },
                                      expression: "select_type"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("b-form-input", {
                                    ref: "filterInput",
                                    staticStyle: {
                                      width: "250px",
                                      height: "35px"
                                    },
                                    attrs: { placeholder: "Search" },
                                    model: {
                                      value: _vm.filter_data,
                                      callback: function($$v) {
                                        _vm.filter_data = $$v
                                      },
                                      expression: "filter_data"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.load_first ? _c("jLoadingTable") : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "container-properties-automation",
                  class: {
                    "show-container-properties-automation": _vm.showProperties,
                    "hide-container-properties-automation": !_vm.showProperties
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex align-items-start justify-content-between"
                    },
                    [
                      _c("div", { staticClass: "label-log-detail" }, [
                        _vm._v("Privileges")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "d-flex align-items-center" }, [
                        _c(
                          "div",
                          {
                            staticClass: "close-properties-automation",
                            on: { click: _vm.hideProperties }
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: require("@/assets/icon/icon-close-properties.svg"),
                                width: "25"
                              }
                            })
                          ]
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _vm.dataSelected
                    ? _c("div", [
                        _c("div", { staticClass: "d-flex" }, [
                          _c(
                            "div",
                            { staticClass: "m__r--7" },
                            [
                              _vm.dataSelected.user_info.photo_url
                                ? _c("b-img", {
                                    staticClass:
                                      "m-1 round-bordered-img\n              img-circle staff-img image-popup-link b-page-theme td",
                                    attrs: {
                                      src: _vm.dataSelected.user_info.photo_url,
                                      rounded: "circle",
                                      alt: "img"
                                    }
                                  })
                                : _c("b-img", {
                                    staticClass:
                                      "m-1 round-bordered-img\n              img-circle staff-img image-popup-link b-page-theme td",
                                    attrs: {
                                      src: require("@/assets/logo/user1.png"),
                                      rounded: "circle",
                                      alt: "img"
                                    }
                                  })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "m__t--5" }, [
                            _c(
                              "div",
                              { staticClass: "privilege-user-info-fullname" },
                              [
                                _vm._v(
                                  _vm._s(_vm.dataSelected.user_info.fullname)
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "privilege-user-info-email" },
                              [_vm._v(_vm._s(_vm.dataSelected.user_info.email))]
                            )
                          ])
                        ]),
                        _c("hr")
                      ])
                    : _c(
                        "div",
                        [
                          !_vm.user_organigram
                            ? _c(
                                "b-form-group",
                                [
                                  _c("label", [_vm._v("User")]),
                                  _vm._v(" "),
                                  _c("j-single-select", {
                                    attrs: {
                                      custom: true,
                                      "is-async": true,
                                      "cache-options": false,
                                      "load-options": _vm.loadUserOptions,
                                      placeholder: "Select User",
                                      "value-format": "object",
                                      label: "email"
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "node-custom",
                                        fn: function(node) {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "d-flex" },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "m__r--7" },
                                                  [
                                                    node.node.raw.photo_url
                                                      ? _c("b-img", {
                                                          staticClass:
                                                            "m-1 round-bordered-img\n                    img-circle staff-img image-popup-link b-page-theme td",
                                                          attrs: {
                                                            src:
                                                              node.node.raw
                                                                .photo_url,
                                                            rounded: "circle",
                                                            alt: "img"
                                                          }
                                                        })
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    !node.node.raw.photo_url
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "privilege-data-manager-initial"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                    " +
                                                                _vm._s(
                                                                  _vm.getUserInitial(
                                                                    node.node
                                                                      .raw
                                                                  )
                                                                ) +
                                                                "\n                  "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "m__t--5" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "privilege-user-info-fullname"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            node.node.raw
                                                              .first_name
                                                          ) +
                                                            " " +
                                                            _vm._s(
                                                              node.node.raw
                                                                .last_name
                                                            )
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "privilege-user-info-email"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            node.node.raw.email
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        }
                                      }
                                    ]),
                                    model: {
                                      value: _vm.user_organigram,
                                      callback: function($$v) {
                                        _vm.user_organigram = $$v
                                      },
                                      expression: "user_organigram"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.user_organigram
                            ? _c("div", { staticClass: "d-flex" }, [
                                _c(
                                  "div",
                                  { staticClass: "m__r--7" },
                                  [
                                    _vm.user_organigram &&
                                    _vm.user_organigram.photo_url
                                      ? _c("b-img", {
                                          staticClass:
                                            "m-1 round-bordered-img\n              img-circle staff-img image-popup-link b-page-theme td",
                                          attrs: {
                                            src: _vm.user_organigram.photo_url,
                                            rounded: "circle",
                                            alt: "img"
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.user_organigram &&
                                    !_vm.user_organigram.photo_url
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "privilege-data-manager-initial"
                                          },
                                          [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(
                                                  _vm.getUserInitial(
                                                    _vm.user_organigram
                                                  )
                                                ) +
                                                "\n            "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "m__t--5" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "privilege-user-info-fullname"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.user_organigram.first_name) +
                                          " " +
                                          _vm._s(_vm.user_organigram.last_name)
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "privilege-user-info-email"
                                    },
                                    [_vm._v(_vm._s(_vm.user_organigram.email))]
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "privilege-data-manager-change-user",
                                    on: {
                                      click: function($event) {
                                        _vm.user_organigram = null
                                      }
                                    }
                                  },
                                  [_vm._v("\n            Change\n          ")]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.user_organigram ? _c("hr") : _vm._e()
                        ],
                        1
                      ),
                  _vm._v(" "),
                  (_vm.user_organigram || _vm.dataSelected) &&
                  _vm.showContainerPrivilege
                    ? _c("div", [
                        _c(
                          "div",
                          {
                            staticClass: "privilege-data-manager-access d-flex"
                          },
                          [
                            _vm._m(0),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "privilege-data-manager-access-toggle"
                              },
                              [
                                _c("j-toggle", {
                                  staticClass: "m__t--12",
                                  model: {
                                    value: _vm.data_privilege.view_only,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.data_privilege,
                                        "view_only",
                                        $$v
                                      )
                                    },
                                    expression: "data_privilege.view_only"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "privilege-data-manager-access d-flex",
                            class: { disabled: _vm.data_privilege.view_only }
                          },
                          [
                            _vm._m(1),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "privilege-data-manager-access-toggle"
                              },
                              [
                                _c("j-toggle", {
                                  staticClass: "m__t--12",
                                  attrs: {
                                    disabled: _vm.data_privilege.view_only
                                  },
                                  model: {
                                    value: _vm.data_privilege.create_table,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.data_privilege,
                                        "create_table",
                                        $$v
                                      )
                                    },
                                    expression: "data_privilege.create_table"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "privilege-data-manager-access d-flex",
                            class: { disabled: _vm.data_privilege.view_only }
                          },
                          [
                            _vm._m(2),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "privilege-data-manager-access-toggle"
                              },
                              [
                                _c("j-toggle", {
                                  staticClass: "m__t--12",
                                  attrs: {
                                    disabled: _vm.data_privilege.view_only
                                  },
                                  model: {
                                    value: _vm.data_privilege.alter_table,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.data_privilege,
                                        "alter_table",
                                        $$v
                                      )
                                    },
                                    expression: "data_privilege.alter_table"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "privilege-data-manager-access d-flex",
                            class: { disabled: _vm.data_privilege.view_only }
                          },
                          [
                            _vm._m(3),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "privilege-data-manager-access-toggle"
                              },
                              [
                                _c("j-toggle", {
                                  staticClass: "m__t--12",
                                  attrs: {
                                    disabled: _vm.data_privilege.view_only
                                  },
                                  model: {
                                    value: _vm.data_privilege.delete_table,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.data_privilege,
                                        "delete_table",
                                        $$v
                                      )
                                    },
                                    expression: "data_privilege.delete_table"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "privilege-data-manager-access d-flex",
                            class: { disabled: _vm.data_privilege.view_only }
                          },
                          [
                            _vm._m(4),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "privilege-data-manager-access-toggle"
                              },
                              [
                                _c("j-toggle", {
                                  staticClass: "m__t--12",
                                  attrs: {
                                    disabled: _vm.data_privilege.view_only
                                  },
                                  model: {
                                    value: _vm.data_privilege.edit_data,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.data_privilege,
                                        "edit_data",
                                        $$v
                                      )
                                    },
                                    expression: "data_privilege.edit_data"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "privilege-data-manager-access d-flex",
                            class: { disabled: _vm.data_privilege.view_only }
                          },
                          [
                            _vm._m(5),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "privilege-data-manager-access-toggle"
                              },
                              [
                                _c("j-toggle", {
                                  staticClass: "m__t--12",
                                  attrs: {
                                    disabled: _vm.data_privilege.view_only
                                  },
                                  model: {
                                    value: _vm.data_privilege.truncate,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.data_privilege,
                                        "truncate",
                                        $$v
                                      )
                                    },
                                    expression: "data_privilege.truncate"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm.isAdmin
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "privilege-data-manager-access d-flex",
                                class: {
                                  disabled: _vm.data_privilege.view_only
                                }
                              },
                              [
                                _vm._m(6),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "privilege-data-manager-access-toggle"
                                  },
                                  [
                                    _c("j-toggle", {
                                      staticClass: "m__t--12",
                                      attrs: {
                                        disabled: _vm.data_privilege.view_only
                                      },
                                      model: {
                                        value: _vm.data_privilege.moderator,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.data_privilege,
                                            "moderator",
                                            $$v
                                          )
                                        },
                                        expression: "data_privilege.moderator"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "privilege-data-manager-access-button",
                      class: {
                        "show-privilege-data-manager-access-button":
                          _vm.showProperties,
                        "hide-privilege-data-manager-access-button": !_vm.showProperties
                      }
                    },
                    [
                      _vm.dataSelected && _vm.isAdmin
                        ? _c(
                            "button",
                            {
                              staticClass: "button-border",
                              on: {
                                click: function($event) {
                                  _vm.actionDeletePrivilege(
                                    _vm.dataSelected.user_company_id
                                  )
                                }
                              }
                            },
                            [
                              _c("i", { staticClass: "fa fa-trash" }),
                              _vm._v(" Delete\n        ")
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "button-border close-prop",
                          on: { click: _vm.hideProperties }
                        },
                        [_vm._v("\n          Close\n        ")]
                      )
                    ]
                  )
                ]
              )
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "privilege-data-manager view_only" }, [
        _vm._v("VIEW ONLY")
      ]),
      _vm._v(" "),
      _c("label", [
        _vm._v("Enables a user to view only a table  in the table group.")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "privilege-data-manager create_table" }, [
        _vm._v("CREATE TABLE")
      ]),
      _vm._v(" "),
      _c("label", [
        _vm._v("Enables a user to create a table in the table group.")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "privilege-data-manager alter_table" }, [
        _vm._v("ALTER TABLE")
      ]),
      _vm._v(" "),
      _c("label", [
        _vm._v("Enables a user to alter ("),
        _c("b", [_vm._v("add, update, delete")]),
        _vm._v(") column any table in the table group.")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "privilege-data-manager delete_table" }, [
        _vm._v("DELETE TABLE")
      ]),
      _vm._v(" "),
      _c("label", [
        _vm._v("Enables a user to delete any table in the table group.")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "privilege-data-manager edit_data" }, [
        _vm._v("EDIT DATA")
      ]),
      _vm._v(" "),
      _c("label", [
        _vm._v("Enables a user to edit ("),
        _c("b", [_vm._v("create, update, delete")]),
        _vm._v(") data record in the table group.")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "privilege-data-manager truncate" }, [
        _vm._v("TRUNCATE")
      ]),
      _vm._v(" "),
      _c("label", [
        _vm._v("Enables a user to truncate ("),
        _c("b", [_vm._v("delete all")]),
        _vm._v(") data record in the table group.")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "privilege-data-manager moderator" }, [
        _vm._v("MODERATOR")
      ]),
      _vm._v(" "),
      _c("label", [
        _vm._v("Enables a user to add privileges user in the table group.")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2be99bc5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2be99bc5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/data-manager/jFormConfig.vue
// module id = null
// module chunks = 